import {action} from "mobx";
import courierRequestService from "services/courierRequestService";
import appStore from "./appStore";

class CourierRequestStore {
    // Courier Request Actions
    @action getCourierRequestList = async (params = {}) => {
        try {
            const response = await courierRequestService.getCourierRequestList(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "Kurye talepleri listesi yüklenirken hata oluştu."
            });
            return false;
        }
    };

    @action createCourierRequest = async params => {
        try {
            const response = await courierRequestService.createCourierRequest(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Kurye talebi başarıyla oluşturuldu."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Kurye talebi oluşturulurken hata oluştu."});
            return false;
        }
    };

    @action updateCourierRequest = async params => {
        try {
            const response = await courierRequestService.updateCourierRequest(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Kurye talebi başarıyla güncellendi."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Kurye talebi güncellenirken hata oluştu."});
            return false;
        }
    };

    @action deleteCourierRequest = async params => {
        try {
            const resultOfRequest = await courierRequestService.deleteCourierRequest(params);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Kurye talebi başarıyla silindi."
            });
            return resultOfRequest.data;
        } catch (error) {
            appStore.openErrorModal({content: "Kurye talebi silinirken hata oluştu."});
            return false;
        }
    };

    @action exportCourierRequestsList = async params => {
        try {
            const response = await courierRequestService.exportCourierRequestsList(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({
                content: "Kurye talepleri listesi export edilirken hata oluştu."
            });
            return false;
        }
    };

    @action closeCourierRequest = async params => {
        try {
            const response = await courierRequestService.closeCourierRequest(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Kurye talebi başarıyla kapatıldı."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Kurye talebi kapatılırken hata oluştu."});
            return false;
        }
    };

    @action getActiveCourierRequestBySubCompanyId = async params => {
        try {
            const response = await courierRequestService.getActiveCourierRequestBySubCompanyId(
                params
            );

            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Kurye talebi alınırken hata oluştu."});
            return false;
        }
    };

    @action listAvailableCourierRequestsByCourierId = async params => {
        try {
            const response = await courierRequestService.listAvailableCourierRequestsByCourierId(
                params
            );
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Kurye talebi listelenirken hata oluştu."});
            return false;
        }
    };
    @action linkCourierToCourierRequest = async params => {
        try {
            const response = await courierRequestService.linkCourierToCourierRequest(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            appStore.showSuccessMessage({
                content: "Kurye, başarıyla talebe bağlandı."
            });
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Kurye talebi bağlanırken hata oluştu."});
            return false;
        }
    };

    @action getCourierRequestCouriersByType = async params => {
        try {
            const response = await courierRequestService.getCourierRequestCouriersByType(params);
            if (response.status !== 200) {
                appStore.openErrorModal({content: response.data.message});
                return false;
            }
            return response.data;
        } catch (error) {
            appStore.openErrorModal({content: "Kurye listesi yüklenirken hata oluştu."});
            return false;
        }
    };
}

export default new CourierRequestStore();
